import { Search, Download } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';
import walletData from '../../../../data/wallet/walletData.json';

const WalletTransactionControls = () => {
  const {
    filteredTransactions,
    searchQuery,
    setSearchQuery,
    filterType,
    setFilterType,
    downloadCSV
  } = useWallet();

  const filterOptions = walletData.filterOptions;

  return (
    <div className="p-4 sm:p-5 lg:p-6 border-b border-slate-100 flex flex-col lg:flex-row justify-between lg:items-center gap-3 sm:gap-4">
      <div>
        <div className="flex items-center gap-2">
          <h2 className="text-base sm:text-lg font-bold text-slate-900 whitespace-nowrap">
            Transaction History
          </h2>
          <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-600 font-semibold text-xs whitespace-nowrap">
            {filteredTransactions.length}
          </span>
        </div>
        <p className="mt-0.5 text-xs text-slate-500 hidden sm:block">
          Click any row to view complete booking details, guest name, partner &amp; payout breakdown.
        </p>
      </div>

      {/* Search & Filter Buttons */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-2.5 w-full lg:w-auto">
        {/* Search Input & Mobile Export Button */}
        <div className="flex items-center gap-2 w-full sm:w-auto">
          <div className="relative flex-1 sm:w-56">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search ref, desc..."
              className="w-full pl-9 pr-3 py-2 bg-slate-50 border border-slate-200 rounded-xl text-xs text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-[#067978]/20 focus:border-[#067978] transition-all"
            />
          </div>

          {/* Export CSV Button (Mobile < 1024px) */}
          <button
            onClick={downloadCSV}
            className="lg:hidden px-3 py-2 bg-slate-50 hover:bg-slate-100 text-slate-700 rounded-xl font-semibold text-xs border border-slate-200 hover:border-slate-300 transition-all flex items-center gap-1.5 shadow-2xs active:scale-95 cursor-pointer whitespace-nowrap shrink-0"
            title="Export CSV"
          >
            <Download size={13} className="text-slate-500" />
            <span className="hidden min-[360px]:inline">Export</span>
          </button>
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto">
          {/* Filter Pills */}
          <div className="grid grid-cols-3 sm:flex items-center bg-slate-100/80 p-1 rounded-xl border border-slate-200/60 w-full sm:w-auto">
            {filterOptions.map((opt) => {
              const isActive = filterType === opt.id;
              let activeClass = 'bg-white text-[#067978] shadow-2xs';
              if (opt.id === 'CREDIT') activeClass = 'bg-white text-emerald-700 shadow-2xs';
              if (opt.id === 'DEBIT') activeClass = 'bg-white text-rose-700 shadow-2xs';

              return (
                <button
                  key={opt.id}
                  onClick={() => setFilterType(opt.id)}
                  className={`px-3 py-1.5 text-xs font-semibold rounded-lg transition-all text-center cursor-pointer ${
                    isActive ? activeClass : 'text-slate-500 hover:text-slate-800'
                  }`}
                >
                  {opt.label}
                </button>
              );
            })}
          </div>

          {/* Export CSV Button (Desktop view >= 1024px) */}
          <button
            onClick={downloadCSV}
            className="hidden lg:flex px-3.5 py-2 bg-slate-50 hover:bg-slate-100 text-slate-700 rounded-xl font-semibold text-xs border border-slate-200 hover:border-slate-300 transition-all items-center gap-1.5 shadow-2xs active:scale-95 cursor-pointer whitespace-nowrap shrink-0"
          >
            <Download size={13} className="text-slate-500" />
            <span>Export CSV</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletTransactionControls;
